export default __webpack_public_path__ + "static/second-0314bd941afa3cd7f524b1044a817a25.png";